import { useParams } from 'react-router-dom';
import { getConnectorsMap } from '@components/layouts/Connectors/connectorsMap';
import { assert } from '@/utils/asserts';

export function ConnectorInfo() {
  const params = useParams();
  const connectorType = params.connectorName as string;
  const connectorComponents = getConnectorsMap().get(connectorType);
  assert(typeof connectorComponents !== 'undefined', 'Wrong connector type provided');
  return connectorComponents.infoComponent;
}
